<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import PrettyChoiceMultiple from '$components/Form/PrettyChoiceMultiple.svelte';
    import PrettyChoice from '$components/Form/PrettyChoice.svelte';
    import Textarea from '$components/Form/Textarea.svelte';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const equipmentTypeOptions = [
        `Ordinateurs portables`,
        `Ordinateurs de bureau`,
        `Imprimantes`,
        `Accessoires`,
        `Consommables`,
        `Solutions IT`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const primaryObjectiveOptions = [
        `Usage personnel`,
        `Usage professionnel`,
        `Mise à niveau de l'équipement existant`,
        `Maintenance`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const companySizeOptions = [
        `Particulier`,
        `PME`,
        `Grande entreprise`,
        `Administration publique`,
        `ONG`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const additionalServicesOptions = [
        `Maintenance`,
        `Installation de réseaux`,
        `Formation`,
        `Audit et conseil IT`,
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.materielInformatique.equipmentType}
        class=""
        let:field
        let:id
        label={`Quel type de matériel informatique recherchez-vous principalement ?`}
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={equipmentTypeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.materielInformatique.primaryObjective}
        class=""
        let:field
        let:id
        label={`Quel est votre principal objectif avec ce matériel informatique ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={primaryObjectiveOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.materielInformatique.companySize}
        class=""
        let:field
        let:id
        label={`Quelle est la taille de votre entreprise ou organisation ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[300px]:grid-cols-2 @[440px]:grid-cols-3 gap-x-6 gap-y-1"
            choices={companySizeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.materielInformatique.additionalServices}
        class=""
        let:field
        let:id
        label={`Avez-vous besoin de services supplémentaires en plus de l'achat de matériel ?`}
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[340px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={additionalServicesOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.message}
        required
        label={'Votre demande'}
        helpLabel="Précisez votre besoin : localisation, délais…"
        let:field
    >
        <Textarea
            {form}
            {field}
            placeholder={`Précisez votre besoin : localisation, délais…`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
